import React from 'react'
import { theme, Text, Box } from '@containous/faency'

export const Message: React.FC = ({ children }) => (
  <Box sx={{ textAlign: 'center', padding: 4, userSelect: 'none' }}>
    <Text sx={{ color: theme.colors.grays[5] }}>{children}</Text>
  </Box>
)
